<template>
  <div id="end-confirm">
    <ipub-model title=""
                width="470px"
                :visable="isVisable"
                :showFooter="false"
                @cancel="cancel">
      <div class="content-center"
           style="">
        <ipub-icon type="iconNotification"
                   style="font-size:60px"
                   class="key-color"></ipub-icon>
        <div class="ipub-h1 content-center"
             style="width:400px">
          Are you sure you want to {{inputData.started?'start':'end'}} {{inputData.types && inputData.types.toLowerCase()}}?
        </div>
        <div>
          <ipub-button type="primary"
                       plain
                       style="width:120px"
                       @click="cancel">
            Cancel
          </ipub-button>
          <ipub-button type="primary"
                       style="margin-left:16px"
                       @click="confirm">
            {{inputData.started?'Confirm':`End ${inputData.types}`}}
          </ipub-button>
        </div>
      </div>

    </ipub-model>
  </div>
</template>

<script>
import macademic from '@/api/macademic'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {

    }
  },
  methods: {
    async confirm () {
      let { id, type, sign, started } = this.inputData
      await macademic.started(id, type, {
        sign,
        started
      })
      this.$emit('confirm')
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
.content-center {
  margin: 0 auto 20px;
  text-align: center;
}
</style>